/**
 * Tanjong Life · L1b · the same self-account question, asked of the external A2A agent.
 *
 * Reached only by intent (`SELF_ACCOUNT`), scoped to `fraud-score-agent`. The answer is
 * three sentences and a pointer at an empty tab, and it is the strongest of the three:
 * asked how it improved, the agent implemented outside the platform can only describe
 * what it does not have. Nothing here is a criticism of the model — it is a good model,
 * and it is invoked on every run of the process. It simply has nowhere to put a lesson.
 *
 * No mutation steps, and no memory to patch. That absence is the beat.
 */
import type { Scenario } from '../director.js';
import { SELF_ACCOUNT } from './tanjong-intents.js';

export const tanjongChatImproveExternal: Scenario = {
  id: 'tanjong-chat-improve-external',
  orgId: 'tanjong-life',
  agentPk: 'fraud-score-agent',
  keywords: [],
  intents: [SELF_ACCOUNT],
  steps: [
    { do: 'say', text: 'I have not.', delay: 500 },
    {
      do: 'say',
      text: 'There is nothing on this side for an improvement to be made out of. No memory in any of the three scopes, no lessons, no facts, no procedures, no probes and no schedule. My release history has one entry and nothing after it. Whatever the carrier does to the model happens on the carrier’s side, on the carrier’s release train, and the first this platform hears of it is a different number coming back.',
      sources: ['Memory · empty in all three scopes', 'Releases · 1'],
      delay: 1200,
    },
    {
      do: 'insight',
      title: 'What that costs, measured',
      body: 'The same hundred and twenty queue conditions were put to four scorers twice, thirty-four days apart, with the panel-tenure weight re-issued in between. I scored 55, then 49. The desk unaided went 63 to 61. The Claims Fraud Analyst went 68 to 63. The SIU Triage Sentinel went 71 to 88. Nobody got worse at the job in those thirty-four days — the ground moved, and only one of the four had anywhere to record that it had.',
      sources: ['SIU Queue Self-Correction Suite · 120 conditions, run twice'],
      delay: 1300,
    },
    {
      do: 'say',
      text: 'Ask me the same claim in six months and you will get the same answer, for the same reason.',
      delay: 900,
    },
  ],
};
